import { jsx as _jsx } from "react/jsx-runtime";
/** Человекочитаемая фраза по виду события. */
function describe(system, resolveName) {
    const actor = resolveName(system.actorId);
    const target = system.targetId ? resolveName(system.targetId) : '';
    switch (system.kind) {
        case 'group_created':
            return `${actor} создал(а) группу${system.value ? ` «${system.value}»` : ''}`;
        case 'group_renamed':
            return `${actor} переименовал(а) группу${system.value ? ` в «${system.value}»` : ''}`;
        case 'member_added':
            return `${actor} добавил(а) ${target}`;
        case 'member_removed':
            return `${actor} удалил(а) ${target}`;
        case 'member_left':
            return `${actor} покинул(а) группу`;
        default:
            return system.value ?? '';
    }
}
export function SystemMessage({ system, resolveName }) {
    const wrap = {
        display: 'flex',
        justifyContent: 'center',
        margin: 'var(--space-2) 0',
    };
    const pill = {
        maxWidth: '80%',
        padding: '4px 12px',
        borderRadius: 'var(--radius-pill)',
        background: 'var(--color-bg-secondary)',
        color: 'var(--color-text-muted)',
        fontSize: 'var(--font-xs)',
        textAlign: 'center',
    };
    return (_jsx("div", { "data-system-message": "", "data-kind": system.kind, style: wrap, children: _jsx("span", { style: pill, children: describe(system, resolveName) }) }));
}
//# sourceMappingURL=SystemMessage.js.map